module.exports = __webpack_public_path__ + "img/0aa361f34bfb893a1cdcc4ff96a5019d.png";